/**
 * Google Map 来源 POI 存储的 key
 */
const SESSION_STORAGE_REFERER_POI = 'refererPoi'

export { SESSION_STORAGE_REFERER_POI }
